"use client";

import dynamic from "next/dynamic";
import { ensureStationPlaces } from "@/lib/search/station-places";

/**
 * 검색바 드롭다운 패널(위치·날짜·무엇을)은 사용자가 칸을 열어야 보인다. 그런데 Navbar 가
 * 모든 페이지에 있어 정적 import 면 패널 코드 — 카테고리 아이콘 맵(Phosphor 6-weight,
 * ~259KB)·전체 카테고리 시트 — 가 전 페이지 공용 번들에 실렸다(감사 06 #2).
 *
 * 그래서 패널은 next/dynamic 으로 나누고, 첫 화면이 끝난 뒤 유휴 시간에 미리 받아 둔다
 * (preloadSearchPanels) — 처음 칸을 열 때 빈 패널이 깜빡이지 않게. 한국 역 사전(~161KB)도
 * 같은 시점에 받는다(lib/search/station-places).
 */
const loadLocation = () => import("./LocationPanel");
const loadDate = () => import("./DatePanel");
const loadWhat = () => import("./WhatPanel");

export const LocationPanel = dynamic(() => loadLocation().then((m) => m.LocationPanel), {
  ssr: false,
});
export const DatePanel = dynamic(() => loadDate().then((m) => m.DatePanel), { ssr: false });
export const WhatPanel = dynamic(() => loadWhat().then((m) => m.WhatPanel), { ssr: false });

let preloaded = false;

/** 패널 청크·역 사전을 유휴 시간에 미리 받는다(한 번만). */
export function preloadSearchPanels(): () => void {
  if (preloaded || typeof window === "undefined") return () => {};
  const run = () => {
    preloaded = true;
    void loadLocation();
    void loadDate();
    void loadWhat();
    void ensureStationPlaces();
  };
  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(run, { timeout: 4000 });
    return () => window.cancelIdleCallback(id);
  }
  const id = setTimeout(run, 2000);
  return () => clearTimeout(id);
}
